import React from "react";
import Grid from "@material-ui/core/Grid";
import Zoom from "react-reveal/Zoom";
import Typed from "react-typed";
import Box from "@material-ui/core/Box";
// import classes from "./Intro.module.css";
import Photo from "./Photo";
import holiImg from "../../asset/images/holi.jpg";
import skydiveImg from "../../asset/images/skydive.jpg";
import milkwayImg from "../../asset/images/milkway.jpg";
import kayakImg from "../../asset/images/kayak.jpg";
import Slide from 'react-reveal/Slide';

let imgs = [
  [milkwayImg, "Explore"],
  [skydiveImg, "Chanllege"],
  [kayakImg, "Nature"],
  [holiImg, "Fun"],
];

let selfIntro = (
  <div>
    <p>
      Yo, I am Yidi Wang! As a rising junior studying Computer Science at Rice
      University, I love programming and enjoy tackling real life problems. Born
      and raised in China, I aspire to become a truly world citizen who is able to see
      things from a broader and clearer perspective.
    </p>
    <p>
      Exploration renders my life of limited length meaning and excitement. I like trying out and
      experiencing new things, whether it is a different sport, embarking on a
      trip to a new land, or rocketing to the moon. Other than coding, my hobbies include jogging,
      hitting the gym, photography, and cooking.
    </p>
  </div>
);
const Intro = () => {
  return (
    <>
      <Zoom>
        <div>
          <Box ml={6} style={{ color: "white", fontSize: "45px" }}>
            <Typed
              strings={[
                "Hi! I am Yidi",
                "A BOY",
                "A MAN",
                "A CODER",
                "A DREAMER",
                "A NATURE ENTHUSIAST",
                "AN EXPLORER",
                "•̀.̫•́✧",
              ]}
              typeSpeed={30}
              backSpeed={50}
              backDelay={2000}
              loop
            />
          </Box>
          <hr style={{ position: "absolute", left: "40px", right: "0" }} />
          <Box
            mx={4}
            style={{
              color: "white",
              fontSize: "18px",
            }}
          >
            {selfIntro}
          </Box>
        </div>
      </Zoom>
      <Slide right>
        <Box mx={4}>
          <Grid container spacing={3}>
            {imgs.map(([img, text],ind) => (
              <Photo text={text} imgURL={img} key ={ind} />
            ))}
          </Grid>
        </Box>
      </Slide>
    </>
  );
};

export default Intro;
